// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { BROKER_PLAN_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS } = require('constants/index');

const morningstarInformationRequestStart = secId => ({
    type: actionTypes.PENSION_PLAN_LEGAL_CONFIRMATION_MORNINGSTAR_INFORMATION_REQUEST_START,
    payload: {
        secId
    }
});

const morningstarInformationRequestSuccess = (screenerResponse, secDetailsResponse) => ({
    type: actionTypes.PENSION_PLAN_LEGAL_CONFIRMATION_MORNINGSTAR_INFORMATION_REQUEST_SUCCESS,
    payload: Object.assign({}, { screenerResponse, secDetailsResponse })
});

const morningstarInformationRequestError = (secId, error) => ({
    type: actionTypes.PENSION_PLAN_LEGAL_CONFIRMATION_MORNINGSTAR_INFORMATION_REQUEST_ERROR,
    payload: {
        secId,
        error
    }
});

const reset = () => ({
    type: actionTypes.PENSION_PLAN_LEGAL_CONFIRMATION_RESET
});

const getPensionPlanSecurityDetails = (secId, screenerResponse) => (dispatch) => {
    const requestData = {
        query: {
            viewId: 'fullNew',
            LanguageId: 'es-ES',
            responseViewFormat: 'json'
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', { type: BROKER_PLAN_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS, id: secId }), requestData)
        .then(secDetailsResponse => dispatch(morningstarInformationRequestSuccess(screenerResponse, secDetailsResponse)))
        .catch(response => {
            if (response.error) {
                dispatch(morningstarInformationRequestError(secId, response.error));
            } else {
                throw response;
            }
        });
};

const fetchPensionPlanMorningstarInformation = secId => (dispatch, getState) => {
    const immPensionPlanLegalConfirmation = getState().pensionPlanLegalConfirmation;

    if (!immPensionPlanLegalConfirmation.get('isFetching')) {
        dispatch(morningstarInformationRequestStart(secId));

        const requestData = {
            query: {
                securityDataPoints:'SecId|Name|CustomBuyFee|CustomSellFee|CustodianFee|DistributionFee|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|DGSCode',
                pageSize: 5000,
                outputType: 'json',
                languageId: 'es-ES',
                currencyId: 'EUR',
                universeIds: 'FOESP$$PEN_2119',
                filters: `secID:EQ:${secId}`
            }
        };

        return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: BROKER_PLAN_LEGAL_DOCUMENT_MORNING_STAREXT_SECURTY_DETAILS }), requestData)
            .then(screenerResponse => {
                if (screenerResponse && screenerResponse.rows && screenerResponse.rows.length) {
                    return dispatch(getPensionPlanSecurityDetails(secId, screenerResponse));
                } else {
                    dispatch(morningstarInformationRequestError(secId, { error: 'Unexisting pension plan' } ));
                }
            })
            .catch(errorResponse => {
                if (errorResponse.error) {
                    dispatch(morningstarInformationRequestError(secId, errorResponse.error));
                } else {
                    throw errorResponse;
                }
            });
    }
};

module.exports = {
    fetchPensionPlanMorningstarInformation,
    reset
};
